import CrudPage from "@/components/admin/CrudPage";
import { Badge } from "@/components/ui/badge";
import { tanggal } from "@/lib/format";

const COND = { baik: "bg-emerald-100 text-emerald-800", "rusak ringan": "bg-[#f6ebd0] text-[#8a6d14]", "rusak berat": "bg-red-100 text-red-800" };

const fields = [
  { name: "name", label: "Nama Barang", required: true },
  { name: "category", label: "Kategori", placeholder: "Elektronik, Perlengkapan Sholat..." },
  { name: "quantity", label: "Jumlah", type: "number", required: true },
  { name: "condition", label: "Kondisi", type: "select", options: [{ value: "baik", label: "Baik" }, { value: "rusak ringan", label: "Rusak Ringan" }, { value: "rusak berat", label: "Rusak Berat" }] },
  { name: "source", label: "Sumber", type: "select", options: [{ value: "beli", label: "Pembelian" }, { value: "hibah", label: "Hibah / Wakaf" }] },
  { name: "acquired_date", label: "Tanggal Perolehan", type: "date" },
  { name: "notes", label: "Catatan", type: "textarea" },
];

const columns = [
  { key: "name", label: "Barang", className: "font-medium" },
  { key: "category", label: "Kategori", className: "text-slate-500" },
  { key: "quantity", label: "Jumlah", className: "text-center" },
  { key: "condition", label: "Kondisi", render: (i) => <Badge className={`${COND[i.condition] || ""} capitalize`}>{i.condition}</Badge> },
  { key: "source", label: "Sumber", className: "capitalize" },
  { key: "acquired_date", label: "Perolehan", render: (i) => tanggal(i.acquired_date) },
];

export default function Inventaris() {
  return (
    <CrudPage
      title="Inventaris Masjid"
      subtitle="Aset dan barang milik masjid"
      endpoint="inventory"
      prefix="admin-inventory"
      itemLabel="Barang"
      fields={fields}
      columns={columns}
      defaults={{ name: "", category: "Perlengkapan", quantity: 1, condition: "baik", source: "beli", acquired_date: "", notes: "" }}
      searchKeys={["name", "category", "condition", "source"]}
    />
  );
}
